// Guest-facing order copy for the explorer cart and menu pages.
//
// The CTA labels are the same for every restaurant. The header, the
// instruction line and the allergy notice stay restaurant-aware: Hyatt
// Regency Maui In-Room Dining keeps its room-service copy with no extra
// notice, and everyone else is told to order with a server, followed by the tip and the
// allergy notice.

const HYATT_MAUI_IN_ROOM_DINING_SLUG = 'hyatt_regency_maui_inroomdining';

const DEFAULT_GUEST_ORDER_HEADER = 'Place Your Order with a Server';
const HYATT_MAUI_IN_ROOM_DINING_HEADER =
  'Dial Room Service to Place Your Order';

const DEFAULT_GUEST_ORDER_INSTRUCTIONS =
  'Pro tip: Make sure to read all special instructions to your server so that your dish is Just Right.';
const HYATT_MAUI_IN_ROOM_DINING_INSTRUCTIONS =
  'Be sure to read your whole order to the person on the other end of the line, including any special instructions or modifications written below. This is the best way to ensure that your meal is "Just Right".';

const DEFAULT_GUEST_ORDER_ALLERGY_NOTICE =
  'Please inform your server of any allergies and confirm that cross-contamination can be avoided, if necessary.';

const GUEST_ORDER_ACTION_LABEL = 'Enjoying Goldi? Register Now!';
const GUEST_ORDER_MENU_ACTION_LABEL = 'View Order';

const isHyattMauiInRoomDining = (restaurantUrlSlug?: string) =>
  restaurantUrlSlug?.toLowerCase() === HYATT_MAUI_IN_ROOM_DINING_SLUG;

export const getGuestOrderInstructions = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_INSTRUCTIONS
    : DEFAULT_GUEST_ORDER_INSTRUCTIONS;

export const getGuestOrderHeader = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_HEADER
    : DEFAULT_GUEST_ORDER_HEADER;

/** Shown under the instructions for every restaurant except Hyatt Maui. */
export const getGuestOrderAllergyNotice = (
  restaurantUrlSlug?: string
): string | null =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? null
    : DEFAULT_GUEST_ORDER_ALLERGY_NOTICE;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getGuestOrderActionLabel = (_restaurantUrlSlug?: string) =>
  GUEST_ORDER_ACTION_LABEL;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getGuestOrderMenuActionLabel = (_restaurantUrlSlug?: string) =>
  GUEST_ORDER_MENU_ACTION_LABEL;

export default getGuestOrderInstructions;
